<!-- eslint-disable vue/html-closing-bracket-newline -->
<template>
  <div>
    <div class="row">
      <div class="col-md-12" v-if="permission.edit && form.id">
        <b-card
          title="Update Job Opportunity
          "
        >
          <b-card-text
            ><validation-observer ref="loginValidation">
              <b-form
                class="auth-login-form mt-2"
                @submit.prevent
                enctype="multipart/form-data"
              >
                <div class="row">
                  <div class="col-md-4">
                    <b-form-group
                      label="Select Department"
                      label-for="job_category_id"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="job_category_id"
                        rules="required"
                      >
                        <v-select
                          id="job_category_id"
                          v-model="form.job_category_id"
                          placeholder="Select Department"
                          :options="categories"
                          label="name"
                          :reduce="(option) => option.id"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group
                      label="Select Job Status"
                      label-for="job_status"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="name"
                        rules="required"
                      >
                        <v-select
                          id="job_status"
                          v-model="form.job_status"
                          placeholder="Select Job Status"
                          :options="jobStatus"
                          label="name"
                          :reduce="(option) => option.id"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group label="Job Deadline" label-for="deadline">
                      <validation-provider
                        #default="{ errors }"
                        name="deadline"
                        rules="required"
                      >
                        <b-form-datepicker
                          id="deadline"
                          v-model="form.deadline"
                          class="mb-1"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <!-- email -->
                    <b-form-group label="Name" label-for="name">
                      <validation-provider
                        #default="{ errors }"
                        name="name"
                        rules="required"
                      >
                        <b-form-input
                          id="name"
                          v-model="form.name"
                          :state="errors.length > 0 ? false : null"
                          name="name"
                          placeholder="Enter Job Name"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <!-- email -->
                    <b-form-group label="Slug" label-for="slug">
                      <validation-provider
                        #default="{ errors }"
                        name="slug"
                        rules="required"
                      >
                        <b-form-input
                          id="slug"
                          v-model="form.slug"
                          :state="errors.length > 0 ? false : null"
                          name="slug"
                          placeholder="Enter job slug name"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>

                  <div class="col-md-12">
                    <div class="d-block" style="height: 400px">
                      <b-form-group label="Description" label-for="description">
                        <validation-provider
                          #default="{ errors }"
                          name="description"
                          rules="required"
                        >
                          <quill-editor
                            id="description"
                            style="height: 300px"
                            class="mb-4"
                            v-model="form.description"
                            name="description"
                            :state="errors.length > 0 ? false : null"
                            placeholder="Enter Your Description"
                          />
                          <div style="clear: both"></div>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="border rounded p-2 mb-2 d-flex align-items-center"
                    >
                      <b-img
                        :src="image"
                        height="300"
                        width="500"
                        class="rounded mr-2 mb-1 mb-md-0"
                      />
                      <b-form-group class="flex-grow-1">
                        <b-form-file
                          class="mt-1"
                          id="image"
                          accept=".jpg, .png, .gif"
                          @change="loadImage($event)"
                          placeholder="Select job image"
                          drop-placeholder="Drop file here..."
                        />
                      </b-form-group>
                      <!-- email -->
                    </div>
                  </div>
                </div>
                <!-- submit buttons -->
                <b-form-checkbox
                  name="status"
                  style="margin-top: 5px"
                  v-model="form.status"
                  switch
                  inline
                >
                </b-form-checkbox>
                <b-button
                  type="submit"
                  class="float-right"
                  variant="primary"
                  @click="validationForm"
                >
                  {{ form.id == "" || form.id == null ? "Create" : "Update" }}
                  {{ form.id }}
                </b-button>
                <b-button
                  type="submit"
                  class="float-right mx-1"
                  variant="outline-primary"
                  @click="Close"
                >
                  Close
                </b-button>
              </b-form>
            </validation-observer></b-card-text
          >
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BMediaBody,
  BMediaAside,
  BMedia,
  BFormFile,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BFormTextarea,
  BFormDatepicker,
} from "bootstrap-vue";
import { required } from "@validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

import _ from "lodash";
export default {
  data() {
    return {
      search: {
        search_data: "",
        paginate: 10,
        page: 1,
      },
      perPageOptions: [10, 25, 50, 100],
      form: {
        id: this.$route.params.id,
        job_category_id: "",
        name: "",
        status: true,
        image: "",
        slug: "",
        deadline: "",
        description: "",
        job_status: "",
      },
      categories: [],
      jobStatus: [
        { id: 1, name: "Full Time" },
        { id: 2, name: "Part Time" },
        { id: 3, name: "Contact" },
      ],
      image: this.$store.state.base_url + "images/course/default.png",
      permission: {
        edit: false,
      },
    };
  },
  mounted() {
    this.getCategories();
    this.Permission();
    if (this.$route.params.id) {
      this.edit();
    }
  },
  methods: {
    async getCategories(page) {
      this.search.page = page == null ? this.search.page : page;
      const res = await this.callApi("get", "app/active/job/category");
      if (res.status == 200) {
        this.categories = res.data.job_categories;
      }
    },

    loadImage(e) {
      this.form.image = e.target.files[0];
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    Close() {
      this.form.id = "";
      this.form.job_category_id = "";
      this.form.name = "";
      this.form.status = true;
      this.form.slug = "";
      this.form.deadline = "";
      this.form.description = "";
      this.form.job_status = "";
      this.image = this.$store.state.base_url + "images/course/default.png";
    },

    async edit() {
      const res = await this.callApi(
        "get",
        "/app/job/opportunitie/" + this.form.id
      );
      if (res.status == 200) {
        this.form.id = res.data.job_opportunitie.id;
        this.form.job_category_id = res.data.job_opportunitie.job_category_id;
        this.form.name = res.data.job_opportunitie.name;
        this.form.status = res.data.job_opportunitie.status = 1 ? true : false;
        this.form.slug = res.data.job_opportunitie.slug;
        this.form.deadline = res.data.job_opportunitie.deadline;
        this.form.description = res.data.job_opportunitie.description;
        this.image =
          this.$store.state.base_url + res.data.job_opportunitie.image;
        this.form.job_status = res.data.job_opportunitie.job_status;
      }
    },

    create() {
      const fd = new FormData();

      fd.append("image", this.form.image);

      fd.append("id", this.form.id);
      fd.append("job_category_id", this.form.job_category_id);
      fd.append("name", this.form.name);
      fd.append("status", this.form.status == true ? 1 : 0);
      fd.append("slug", this.form.slug);
      fd.append("deadline", this.form.deadline);
      fd.append("description", this.form.description);
      fd.append("job_status", this.form.job_status);
      if (this.form.id) {
        fd.append("_method", "PUT");
      }
      axios
        .post("/app/job/opportunitie/" + this.form.id, fd)
        .then((res) => {
          this.Close();
          this.$router.push({ name: "job" });
          // this.s(res.data.message);
        })
        .catch((e) => {
          this.e(e.response.data?.message);
        });
    },

    validationForm() {
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          this.create();
        }
      });
    },

    async Permission() {
      const permissions = await this.callApi("post", "/app/permission");
      permissions.data.permissions.forEach((permission) => {
        if (permission.slug == "job.opportunitie.edit") {
          this.permission.edit = true;
        }
      });
    },
  },

  components: {
    quillEditor,
    vSelect,
    BCard,
    BCardText,
    BLink,
    BTabs,
    BTab,
    BMedia,
    BFormFile,
    BFormTextarea,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BMediaAside,
    BMediaBody,
    BFormDatepicker,
  },
};
</script>

<style></style>
